import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export let BETS_SEARCH_STATUSES = () => ({
    T : {label: window.Translation(msg`Tutte`), description: window.Translation(msg`Tutte le scommesse`)},
    N : {label: window.Translation(msg`Aperte`), description: window.Translation(msg`Scommesse aperte`)},
    V : {label: window.Translation(msg`Vinte`), description: window.Translation(msg`Scommesse vinte`)},
    P : {label: window.Translation(msg`Perse`), description: window.Translation(msg`Scommesse perse`)},
    A : {label: window.Translation(msg`Annullate`), description: window.Translation(msg`Scommesse annullate`)},
    D : {label: window.Translation(msg`Rifiutate`), description: window.Translation(msg`Scommesse rifiutate`)},
    S : {label: window.Translation(msg`Sistemi Completati`), description: window.Translation(msg`Scommesse sistema refertate completamente`)},
    PAID : {label: window.Translation(msg`Pagate`), description: window.Translation(msg`Scommesse pagate`)},
    M : {label: window.Translation(msg`Da Pagare`), description: window.Translation(msg`Scommesse da pagare`)}
});

/*
 * Possibili stati di un ticket
 */
export let BETS_STATUS = status => ({
    V: window.Translation(msg`Vincente`),
    P: window.Translation(msg`Perdente`),
    M: window.Translation(msg`Monetizza`),
    N: window.Translation(msg`In Corso`),
    C: window.Translation(msg`Rifiutata`),
    D: window.Translation(msg`Non Accettata`),
    A: window.Translation(msg`Annullata`),
    R: window.Translation(msg`In Riserva`),
    S: window.Translation(msg`Sistema Completo`)
})[status] || status;

/*
 * Possibili stati delle outcomes di un ticket
 */
export let OUTCOMES_STATUS = status => ({
    W: <Trans>Vincente</Trans>,
    V: <Trans>Vincente</Trans>,
    L: <Trans>Perdente</Trans>,
    P: <Trans>Perdente</Trans>,
    H: <Trans>Mezza Vincente</Trans>,
    Z: <Trans>Mezza Perdent</Trans>,
    X: <Trans>Void</Trans>,
    N: ''
})[status] || status;